"use strict";
// tslint:disable
// eslint-disable
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScenarioExecutionApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class ScenarioExecutionApi extends runtime.BaseAPI {
    /**
     * Cancel scenario execution
     */
    cancelScenarioExecutionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.groupId === null || requestParameters.groupId === undefined)) {
                throw new runtime.RequiredError('groupId', 'Required parameter requestParameters.groupId was null or undefined when calling cancelScenarioExecution.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioExecution/{groupId}/cancel`.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters.groupId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Cancel scenario execution
     */
    cancelScenarioExecution(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.cancelScenarioExecutionRaw(requestParameters);
        });
    }
    /**
     * Create execution group according scenario\'s submodel execution setup
     * Create execution
     */
    createScenarioExecutionGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling createScenarioExecutionGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioExecution/{scenarioId}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioExecutionGroupDTOFromJSON(jsonValue));
        });
    }
    /**
     * Create execution group according scenario\'s submodel execution setup
     * Create execution
     */
    createScenarioExecutionGroup(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createScenarioExecutionGroupRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Run all execution according provided group id
     * Run execution group
     */
    executeScenarioRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.groupId === null || requestParameters.groupId === undefined)) {
                throw new runtime.RequiredError('groupId', 'Required parameter requestParameters.groupId was null or undefined when calling executeScenario.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioExecution/{groupId}/execute`.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters.groupId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Run all execution according provided group id
     * Run execution group
     */
    executeScenario(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.executeScenarioRaw(requestParameters);
        });
    }
    /**
     * Get scenario executions based on provided criteria. Supports paginated output.
     * Find scenario executions
     */
    findScenarioExecutionsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.orderBy === null || requestParameters.orderBy === undefined)) {
                throw new runtime.RequiredError('orderBy', 'Required parameter requestParameters.orderBy was null or undefined when calling findScenarioExecutions.');
            }
            const queryParameters = {};
            if (requestParameters.orderDesc !== undefined) {
                queryParameters['orderDesc'] = requestParameters.orderDesc;
            }
            if (requestParameters.pageIndex !== undefined) {
                queryParameters['pageIndex'] = requestParameters.pageIndex;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.orderBy !== undefined) {
                queryParameters['orderBy'] = requestParameters.orderBy;
            }
            if (requestParameters.status !== undefined) {
                queryParameters['status'] = requestParameters.status;
            }
            if (requestParameters.executedBy !== undefined) {
                queryParameters['executedBy'] = requestParameters.executedBy;
            }
            if (requestParameters.modelUuid !== undefined) {
                queryParameters['modelUuid'] = requestParameters.modelUuid;
            }
            if (requestParameters.filename !== undefined) {
                queryParameters['filename'] = requestParameters.filename;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioExecution`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioExecutionListDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get scenario executions based on provided criteria. Supports paginated output.
     * Find scenario executions
     */
    findScenarioExecutions(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.findScenarioExecutionsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get scenario executions based on provided criteria by grouping with groupId. Supports paginated output.
     * Find all scenario executions by grouping with groupId
     */
    getAllInstanceByGroupingWithGroupIdRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.orderBy === null || requestParameters.orderBy === undefined)) {
                throw new runtime.RequiredError('orderBy', 'Required parameter requestParameters.orderBy was null or undefined when calling getAllInstanceByGroupingWithGroupId.');
            }
            const queryParameters = {};
            if (requestParameters.orderDesc !== undefined) {
                queryParameters['orderDesc'] = requestParameters.orderDesc;
            }
            if (requestParameters.pageIndex !== undefined) {
                queryParameters['pageIndex'] = requestParameters.pageIndex;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.orderBy !== undefined) {
                queryParameters['orderBy'] = requestParameters.orderBy;
            }
            if (requestParameters.status !== undefined) {
                queryParameters['status'] = requestParameters.status;
            }
            if (requestParameters.executedBy !== undefined) {
                queryParameters['executedBy'] = requestParameters.executedBy;
            }
            if (requestParameters.modelUuid !== undefined) {
                queryParameters['modelUuid'] = requestParameters.modelUuid;
            }
            if (requestParameters.filename !== undefined) {
                queryParameters['filename'] = requestParameters.filename;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioExecution/instances/all`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioExecutionGroupListDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get scenario executions based on provided criteria by grouping with groupId. Supports paginated output.
     * Find all scenario executions by grouping with groupId
     */
    getAllInstanceByGroupingWithGroupId(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAllInstanceByGroupingWithGroupIdRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Return scenario execution group according provided group id
     * Get execution gorup
     */
    getExecutionGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.groupId === null || requestParameters.groupId === undefined)) {
                throw new runtime.RequiredError('groupId', 'Required parameter requestParameters.groupId was null or undefined when calling getExecutionGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/scenarioExecution/{groupId}`.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters.groupId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ScenarioExecutionGroupDTOFromJSON(jsonValue));
        });
    }
    /**
     * Return scenario execution group according provided group id
     * Get execution gorup
     */
    getExecutionGroup(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getExecutionGroupRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.ScenarioExecutionApi = ScenarioExecutionApi;
